// extracted by mini-css-extract-plugin
module.exports = {"grey200":"#E6E6EC","wrapper":"FAQ_wrapper___PbEs"};